import { type TextInputProps } from 'react-native';

/**
 * Input props enforcing a claim gate's block. `editable: false` alone is not
 * enough on web — react-native-web renders it as `readOnly`, which keeps the
 * input Tab-focusable, and a focus landing on a blocked field announces a
 * claim: co-editing entered without the "Edit anyway" step. Dropping the
 * input from the tab order closes that path; an override's programmatic
 * focus still lands (`tabIndex: -1` only skips sequential traversal).
 */
export function blockedInputProps(
  blocked: boolean,
): Pick<TextInputProps, 'editable' | 'tabIndex'> {
  return { editable: !blocked, tabIndex: blocked ? -1 : 0 };
}
